import { defineMessages } from 'react-intl';

export default defineMessages({
  import: 'Import content from another survey',

  editContent: 'Edit {type}',
  activeTooltip: 'Disable',
  inactiveTooltip: 'Enable',
  confirmDeleteContent: 'Are you sure you want to delete content?',
  delete: 'Delete',
  save: 'Save',
  questionHasResponses: 'This question has {responses} response(s).',
  blockHasQuestionsWithResponses: 'This block contains question(s) with response(s).',
  empty: 'Drag content from the left hand side to add.',

  contentSaveSuccess: 'Survey content saved!',
  contentSaveError: 'Failed to save content. Please try again later.',
});
